import { produce } from 'immer';
import type { TypedReduxActionOutcomes } from 'app/store/storeTypes';
import type { ProjectDeploymentEntry } from 'app/lib/types/server';
import { type TransformedDeploymentOverviewEntry, transformOverviewEntries } from './transformer';
import {
    GET_PROJECT_DEPLOYMENTS_ACTION_TYPE,
    GET_DEPLOYMENT_OVERVIEW_ACTION_TYPE
} from './types.js';

export type ProjectDeploymentEntryWithProjectSlug = ProjectDeploymentEntry & {
    projectSlug: string;
};

export type DeploymentsStateSlice = {
    overviewEntries: TransformedDeploymentOverviewEntry[];
    isLoadingProjectOutputs: boolean;
    projectOutputsById: Record<string, ProjectDeploymentEntryWithProjectSlug[]>;
};

export const INITIAL_STATE: DeploymentsStateSlice = {
    overviewEntries: [],
    isLoadingProjectOutputs: false,
    projectOutputsById: {}
};

export const deploymentsReducer = produce((draft, action: TypedReduxActionOutcomes) => {
    switch (action.type) {
        case GET_DEPLOYMENT_OVERVIEW_ACTION_TYPE.SUCCEEDED: {
            const { entries } = action.payload;
            draft.overviewEntries = transformOverviewEntries(entries);
            break;
        }
        case GET_PROJECT_DEPLOYMENTS_ACTION_TYPE.STARTED:
            draft.isLoadingProjectOutputs = true;
            break;
        case GET_PROJECT_DEPLOYMENTS_ACTION_TYPE.ENDED:
            draft.isLoadingProjectOutputs = false;
            break;
        case GET_PROJECT_DEPLOYMENTS_ACTION_TYPE.SUCCEEDED:
            draft.projectOutputsById[action.params.spaceUid] = action.payload.entries;
            break;
        default:
    }
}, INITIAL_STATE);
